import React from 'react';
import { FiChevronRight, FiHome } from 'react-icons/fi';
import { useFormsRouteParams } from '../../../hooks/useRouteParams';

const FormsBreadcrumb = ({ forms = [], submissions = [] }) => {
	const { 
		formId, 
		submissionId, 
		categoryName, 
		currentView, 
		navigate 
	} = useFormsRouteParams();

	const buildBreadcrumbs = () => {
		const breadcrumbs = [
			{
				label: 'Forms',
				onClick: () => navigate.toDashboard(),
				active: currentView === 'dashboard',
			}
		];

		// Add category breadcrumb
		if (categoryName) {
			breadcrumbs.push({
				label: `Category: ${categoryName}`,
				onClick: () => navigate.toCategory(categoryName),
				active: currentView === 'category-filter',
			});
		}

		// Add submissions breadcrumb
		if (currentView.includes('submission')) {
			breadcrumbs.push({
				label: 'Submissions',
				onClick: () => navigate.toSubmissions(),
				active: currentView === 'submissions-list',
			});
		}

		// Add specific form breadcrumb
		if (formId && forms.length > 0) {
			const form = forms.find(f => f.id === formId);
			if (form) {
				breadcrumbs.push({
					label: form.name,
					onClick: () => navigate.toForm(formId),
					active: currentView === 'form-view',
				});
			}
		}

		// Add specific submission breadcrumb
		if (submissionId && submissions.length > 0) {
			const submission = submissions.find(s => s.id === submissionId);
			if (submission) {
				breadcrumbs.push({
					label: `Submission #${submissionId}`,
					onClick: () => navigate.toSubmission(submissionId),
					active: currentView === 'view-submission',
				});

				// Add edit mode breadcrumb
				if (currentView === 'edit-submission') {
					breadcrumbs.push({
						label: 'Edit',
						active: true,
					});
				}
			}
		}

		return breadcrumbs;
	};

	const breadcrumbs = buildBreadcrumbs();

	// Don't show breadcrumbs for dashboard view only
	if (breadcrumbs.length <= 1) {
		return null;
	}

	return (
		<nav className="mb-6" aria-label="Breadcrumb">
			<ol className="flex items-center space-x-2 text-sm font-montserrat-regular">
				{breadcrumbs.map((crumb, index) => (
					<li key={index} className="flex items-center">
						{index > 0 && (
							<FiChevronRight className="h-4 w-4 text-gray-400 mx-2" />
						)}
						{crumb.onClick && !crumb.active ? (
							<button
								onClick={crumb.onClick}
								className="text-gray-600 hover:text-gray-900 hover:underline focus:outline-none focus:underline transition-colors"
							>
								{crumb.label}
							</button>
						) : (
							<span 
								className={`${
									crumb.active 
										? 'text-gray-900 font-montserrat-medium' 
										: 'text-gray-500'
								}`}
							>
								{crumb.label}
							</span>
						)}
					</li>
				))}
			</ol>
		</nav>
	);
};

export default FormsBreadcrumb;